import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './_workoutForm.css'
import { CharField } from 'components/forms'
import { FormattedDistance } from 'shared/units'

export default function Distance (props) {
  return (
    <CharField
      {...props}
      bold
      short
      type='number'
      min='0'
      step='any'
      name='distance'
      inputContainerClassName={styles.shortInput}
      labelComponent={(
        <FormattedMessage
          id='workouts.create.distance'
          defaultMessage='Distance'
        />
      )}
      afterComponent={(
        <span className={styles.fieldUnit}>
          <FormattedDistance id='workouts.create.distance_unit' />
        </span>
      )}
    />
  )
}
